import { Handle, Position } from '@xyflow/react';
import { GitBranch } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function ConditionNode({ id, data, selected }) {
  const summary =
    data.leftOperand && data.operator
      ? `If ${data.leftOperand} ${data.operator} ${data.rightOperand || ''}`.trim()
      : null;

  const branchHandles = (
    <>
      <Handle
        type="source"
        position={Position.Bottom}
        id="true"
        className="!w-3 !h-3 !bg-green-500 !border-2 !border-white"
        style={{ left: '35%' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="false"
        className="!w-3 !h-3 !bg-red-400 !border-2 !border-white"
        style={{ left: '65%' }}
      />
      <div className="flex justify-between px-6 pb-1">
        <span className="text-[9px] text-green-600 font-medium">True</span>
        <span className="text-[9px] text-red-400 font-medium">False</span>
      </div>
    </>
  );

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.logic}
      icon={GitBranch}
      label={data.label}
      outputHandles={branchHandles}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
